import { useContext } from "react";
import { useSelector } from "react-redux";
import { ZoneEditionError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ZoneEditionError;
  editZone(request: Boundaries["editZone"]["request"]): void;
}

function useZoneEdition(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isZoneEditionRequestPending),
    isRequestSuccess: useSelector(selector.isZoneEditionRequestSuccess),
    isRequestFailure: useSelector(selector.isZoneEditionRequestFailure),
    error: useSelector(selector.getZoneEditionError),
    editZone: core.editZone,
  };
}

export { useZoneEdition };
